import React from 'react';
import Header from '../Header/Header';
import about from '../../media/pictures/about.jpeg';

const About = () => {
    return (
        <div>
            <Header props="yes"></Header>
            <section className="mt-24 mb-16 md:mx-36">

                <div className="md:flex mx-4 space-y-8">
                    <article className="md:w-1/2 md:text-left space-y-6 my-auto">
                        <h1 className="text-7xl">Hello!</h1>
                        <h1 className="text-7xl">I'm Kamil</h1>
                        <p>
                            I was born in Bangladesh in 2002. Now I am completing my
                            undergraduate
                            study at Asia Pacific
                            University of Technology & Innovation, Malaysia majoring in Computer Science
                            (Intelligent System). The first time I
                            explored the world of programming in 2016 with C programming. Now I am a MERN Stack Web Developer seeking Internship. Apart from coding, I am passionate about reading books and travelling. I also like to play guiter.
                        </p>
                    </article>
                    <div className="md:w-1/2"><img className="my-auto mx-auto md:w-3/5" src={about} alt="kamil hassan" /></div>
                </div>
            </section>
        </div>
    );
};

export default About;